import { Button } from '@mui/material';
import { OnboardingStatus } from '@qdrant/qdrant-cloud-public-api/iam/v1';
import { PlusIcon } from 'lucide-react';
import { useCallback } from 'react';
import { useAuthenticatedUser, useUserAccounts } from '@/routes/_authenticated.hooks';
import { useRouteNavigate } from '@/routes/_authenticated/_dashboard/accounts/index.hooks';

export const DashboardAccountCreationAction = ({
  variant,
  onCreateAccountClick,
  disabled,
}: {
  variant: 'outlined' | 'contained';
  onCreateAccountClick?: () => void;
  disabled?: boolean;
}) => {
  const { onboardingStatus } = useAuthenticatedUser();
  const navigate = useRouteNavigate();
  const accounts = useUserAccounts();
  const accountCount = accounts.length;

  const handleCreateAccountClick = useCallback(() => {
    if (onboardingStatus !== OnboardingStatus.COMPLETED && accountCount === 0) {
      return navigate({ to: '/onboarding/1' });
    }
    return onCreateAccountClick?.();
  }, [onboardingStatus, navigate, accountCount, onCreateAccountClick]);
  return (
    <Button
      fullWidth={true}
      startIcon={<PlusIcon size={18} />}
      onClick={handleCreateAccountClick}
      variant={variant}
      disabled={disabled}
    >
      Create New Account
    </Button>
  );
};
